import cn from "@/utils/cn"
import { ComponentPropsWithoutRef } from "react"

const HeaderCell = ({
  className,
  children,
  ...otherProps
}: ComponentPropsWithoutRef<"div">) => (
  <div
    className={cn(
      "flex items-center justify-start py-3 font-bold text-primary",
      className
    )}
    {...otherProps}
  >
    {children}
  </div>
)

export default HeaderCell
